export default class Loader {
  constructor({ minimumTime, cssClass }) {
    this.minimumTime = minimumTime;
    this.cssClass = cssClass;
    this.loaderElement = document.querySelector(".js-loader").cloneNode(true);
  }

  toggle(isToggled = false) {
    if (!this.loaderElement) {
      return;
    }

    if (!isToggled) {
        const timer = setTimeout(() => {
            this.loaderElement.classList.remove("shown");
            this.loaderElement.remove();
            clearTimeout(timer);
        }, this.minimumTime);
      return;
    }

    this.loaderElement.classList.add("shown");
    document.body.append(this.loaderElement);
  }
}
